import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Jumlah Hari Antara Dua Tanggal - Hitung Perbedaan Antara Dua Tanggal dengan Akurat";
const DESCRIPTION =
  "Kalkulator hari gratis membantu Anda menghitung jumlah hari, minggu, bulan, dan tahun antara dua tanggal dengan akurasi tinggi. Hitung periode waktu, durasi proyek, usia, liburan, dan tenggat waktu dengan mudah.";
const KEYWORDS =
  "kalkulator hari, perhitungan perbedaan antara dua tanggal, jumlah hari antara dua tanggal, kalkulator tanggal, perhitungan periode waktu, perbedaan antara tanggal, perhitungan usia, kalkulator periode waktu, perhitungan hari tersisa";
const OG_URL = "https://do-calculate.com/calculator/id/days-calculator/";
// JSON-LD Schema for SEO
const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Kalkulator Jumlah Hari Antara Dua Tanggal",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Beranda",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Kalkulator",
        item: "https://do-calculate.com/id/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Kalkulator Hari",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Bagaimana cara menghitung perbedaan antara dua tanggal?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Masukkan tanggal mulai dan tanggal selesai di kolom yang disediakan, lalu tekan tombol hitung untuk mendapatkan perbedaan dalam berbagai satuan (hari, minggu, bulan, tahun, jam).",
        },
      },
      {
        "@type": "Question",
        name: "Apa saja kegunaan kalkulator hari?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Kalkulator ini digunakan untuk menghitung durasi proyek, usia secara detail, hari tersisa untuk acara, periode liburan, perhitungan kontrak, perencanaan acara, dan semua operasi perhitungan yang berkaitan dengan tanggal.",
        },
      },
    ],
  },
];

const GREGORIAN_MONTHS = [
  "Januari", "Februari", "Maret", "April",
  "Mei", "Juni", "Juli", "Agustus",
  "September", "Oktober", "November", "Desember"
];
function DaysCalculator() {
  // State tanggal mulai
  const [startD, setStartD] = useState({ day: "1", month: "1", year: "2024" });
  // State tanggal selesai
  const [endD, setEndD] = useState({ day: "1", month: "1", year: "2025" });

  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const calculateDifference = () => {
    const start = new Date(parseInt(startD.year), parseInt(startD.month) - 1, parseInt(startD.day));
    const end = new Date(parseInt(endD.year), parseInt(endD.month) - 1, parseInt(endD.day));

    if (start > end) {
      setError("Tanggal mulai harus sebelum tanggal selesai");
      setResult(null);
      return;
    }

    const timeDiff = Math.abs(end - start);
    const totalDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const totalHours = Math.floor(timeDiff / (1000 * 60 * 60));
    const totalMinutes = Math.floor(timeDiff / (1000 * 60));
    const totalSeconds = Math.floor(timeDiff / 1000);
    const totalWeeks = Math.floor(totalDays / 7);
    const remainingDaysAfterWeeks = totalDays % 7;

    // Perhitungan perkiraan untuk tahun dan bulan
    const years = Math.floor(totalDays / 365.25);
    const remainingDaysAfterYears = totalDays % 365.25;
    const months = Math.floor(remainingDaysAfterYears / 30.44);
    const days = Math.floor(remainingDaysAfterYears % 30.44);
    const remainingMonthsAfterYears = Math.floor(remainingDaysAfterYears / 30.44);
    const remainingDaysAfterMonths = Math.floor(remainingDaysAfterYears % 30.44);

    setResult({
      totalDays,
      totalHours,
      totalMinutes,
      totalSeconds,
      totalWeeks,
      remainingDaysAfterWeeks,
      years,
      months,
      days,
      remainingMonthsAfterYears,
      remainingDaysAfterMonths,
      startDateFormatted: start.toLocaleDateString('id-ID', { year: 'numeric', month: 'long', day: 'numeric' }),
      endDateFormatted: end.toLocaleDateString('id-ID', { year: 'numeric', month: 'long', day: 'numeric' }),
    });
    setError("");
  };

  const handleClear = () => {
    setStartD({ day: "1", month: "1", year: "2024" });
    setEndD({ day: "1", month: "1", year: "2025" });
    setResult(null);
    setError("");
  };

  // Komponen pembantu untuk pemilih tanggal
  const DateSelector = ({ label, value, onChange }) => (
    <div className="row mb-3 align-items-center">
      <div className="col-sm-12 col-md-3">
        <label className="fw-bold">{label}</label>
      </div>
      <div className="col-sm-12 col-md-9">
        <div className="d-flex gap-2 flex-wrap">
          <select className="form-select w-auto" value={value.day} onChange={(e) => onChange({ ...value, day: e.target.value })}>
            {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
          </select>
          <select className="form-select w-auto" value={value.month} onChange={(e) => onChange({ ...value, month: e.target.value })}>
            {GREGORIAN_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
          </select>
          <select className="form-select w-auto" value={value.year} onChange={(e) => onChange({ ...value, year: e.target.value })}>
            {Array.from({ length: 150 }, (_, i) => new Date().getFullYear() + 20 - i).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>
    </div>
  );
  return (
    <div className="ltr" >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>Kalkulator Jumlah Hari Antara Dua Tanggal</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                Selamat datang di Kalkulator Perbedaan Antara Dua Tanggal! Alat canggih ini membantu Anda menghitung perbedaan secara akurat antara dua tanggal tertentu menggunakan berbagai satuan waktu seperti hari, minggu, bulan, tahun, jam, menit, dan detik. Baik Anda perlu merencanakan tugas, mengelola proyek, atau sekadar mengetahui periode waktu antara dua tanggal untuk tujuan apa pun, alat ini menyediakan semua yang Anda butuhkan dengan cepat dan mudah.
              </p>
              Ikuti langkah-langkah berikut untuk menggunakan kalkulator:
              <ul>
                <li>Masukkan tanggal mulai dan tanggal selesai di kolom yang disediakan.</li>
                <li>Tekan tombol "Hitung" untuk mendapatkan perbedaan antara kedua tanggal.</li>
                <li>Hasil akan muncul dalam berbagai format sesuai kebutuhan Anda.</li>
              </ul>
            </div>
            <hr />
            <MobileUnderCalAds />
            {/* Calculator Section */}
            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>
                  Hitung Perbedaan Antara Dua Tanggal dengan Mudah
                </h2>
              </div>
              {/* Date Inputs */}
              <div className="row mb-3 align-items-center">
                <DateSelector label="Tanggal Mulai:" value={startD} onChange={setStartD} />
                <DateSelector label="Tanggal Selesai:" value={endD} onChange={setEndD} />

                <div className="text-center mt-4">
                  <button onClick={calculateDifference} className="btn btn-success btn-lg me-2 px-5">Hitung</button>
                  <button onClick={handleClear} className="btn btn-secondary btn-lg px-5" style={{marginRight:'3px'}}>Hapus</button>
                </div>
              </div>
              {/* Buttons */}

              {/* Error Message */}
              {error && <div className="alert alert-danger mt-3">{error}</div>}
              {/* Results */}
              {result && (
                <div className="mt-4">
                  <h3
                    style={{
                      fontSize: "18px",
                      marginBottom: "15px",
                      textAlign: "center",
                    }}
                  >
                    <strong>Hasil:</strong>
                  </h3>

                  {/* Main Results Table */}
                  <div className="table-container">
                    <table className="table border">
                      <thead>
                        <tr style={{ backgroundColor: "#f8f9fa" }}>
                          <th style={{ padding: "12px", borderBottom: "2px solid #dee2e6" }}>Satuan</th>
                          <th style={{ padding: "12px", borderBottom: "2px solid #dee2e6" }}>Nilai</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>Hari</td>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>{result.totalDays} hari</td>
                        </tr>
                        <tr>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>Minggu</td>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>{result.totalWeeks} minggu {result.remainingDaysAfterWeeks} hari</td>
                        </tr>
                        <tr>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>Bulan</td>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>{result.months} bulan {result.remainingDaysAfterMonths} hari</td>
                        </tr>

                        {result.years > 0 && (
                          <tr>
                            <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>Tahun</td>
                            <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>{result.years} tahun {result.remainingMonthsAfterYears} bulan</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Format Tambahan Hasil</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
                          <li>
                            ⏰ <strong>Total Jam:</strong>{" "}
                            {result.totalHours.toLocaleString()} jam
                          </li>
                          <li>
                            ⏰ <strong>Total Menit:</strong>{" "}
                            {result.totalMinutes.toLocaleString()} menit
                          </li>
                          <li>
                            ⏰ <strong>Total Detik:</strong>{" "}
                            {result.totalSeconds.toLocaleString()} detik
                          </li>
                          <li>
                            📅 <strong>Total Minggu:</strong>{" "}
                            {result.totalWeeks.toLocaleString()} minggu
                          </li>
                          <li>
                            📅 <strong>Total Bulan:</strong>{" "}
                            {Math.floor(result.totalDays / 30.44).toLocaleString()} bulan
                          </li>
                          {result.years >= 1 && (
                            <li>
                              📅 <strong>Total Tahun:</strong>{" "}
                              {result.years} tahun
                            </li>
                          )}
                        </ul>
                        <div
                          className="alert alert-info mt-3"
                          style={{ fontSize: "14px" }}
                        >
                          <strong>💡 Tips:</strong> Gunakan format yang sesuai
                          dengan kebutuhan Anda - hari untuk periode pendek, bulan untuk proyek
                          menengah, tahun untuk periode panjang.
                        </div>
                      </div>
                    </div>

                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Detail Tanggal</strong>
                      </div>
                      <div className="info-section-body">
                        <div style={{ lineHeight: "1.8" }}>
                          <p>
                            <strong>📅 Tanggal Mulai:</strong><br />
                            {result.startDateFormatted}
                          </p>
                          <p>
                            <strong>📅 Tanggal Selesai:</strong><br />
                            {result.endDateFormatted}
                          </p>
                          <hr />
                          <p>
                            <strong>⏱️ Total Durasi:</strong><br />
                            {result.totalDays} hari
                          </p>
                          {result.years > 0 && (
                            <p>
                              <strong>Dalam Format Lengkap:</strong><br />
                              {result.years} tahun, {result.remainingMonthsAfterYears} bulan, {result.remainingDaysAfterMonths} hari
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Informational Content */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>Apa Itu Kalkulator Hari Antara Dua Tanggal?</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Kalkulator Hari Antara Dua Tanggal</strong> adalah alat elektronik gratis
                  yang membantu Anda menghitung perbedaan waktu antara dua tanggal dengan akurasi tinggi. Kalkulator ini memungkinkan Anda:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Menghitung Jumlah Hari:</strong> Mengetahui jumlah hari yang tepat antara dua tanggal
                  </li>
                  <li>
                    <strong>Konversi Otomatis:</strong> Menampilkan hasil dalam berbagai satuan (minggu, bulan, tahun)
                  </li>
                  <li>
                    <strong>Perhitungan Akurat:</strong> Mempertimbangkan tahun kabisat dan jumlah hari setiap bulan
                  </li>
                  <li>
                    <strong>Hasil Lengkap:</strong> Menampilkan perbedaan dalam jam, menit, dan detik juga
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Cara Menggunakan Kalkulator:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>Masukkan tanggal mulai di kolom pertama</li>
                  <li>Masukkan tanggal selesai di kolom kedua</li>
                  <li>Tekan tombol "Hitung"</li>
                  <li>Hasil akan langsung muncul dalam berbagai format</li>
                  <li>Anda dapat membuka bagian untuk melihat detail tambahan</li>
                </ol>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 Catatan:</strong> Tanggal mulai harus sebelum tanggal
                  selesai. Kalkulator mempertimbangkan semua hari termasuk tahun
                  kabisat untuk mendapatkan hasil yang paling akurat.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Penggunaan Kalkulator Hari</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  Dalam Pekerjaan dan Bisnis:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Manajemen Proyek:</strong> Menghitung durasi proyek dan tugas
                  </li>
                  <li>
                    <strong>Kontrak dan Perjanjian:</strong> Menghitung durasi kontrak dan tanggal berakhir
                  </li>
                  <li>
                    <strong>Tenggat Waktu:</strong> Mengetahui waktu tersisa untuk menyelesaikan tugas
                  </li>
                  <li>
                    <strong>Liburan:</strong> Menghitung hari libur tahunan dan sakit
                  </li>
                  <li>
                    <strong>Masa Percobaan:</strong> Menghitung durasi masa percobaan karyawan
                  </li>
                  <li>
                    <strong>Garansi:</strong> Mengetahui sisa masa garansi produk
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Dalam Pendidikan dan Studi:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Kalender Akademik:</strong> Menghitung jumlah hari dalam semester
                  </li>
                  <li>
                    <strong>Persiapan Ujian:</strong> Mengetahui hari tersisa untuk persiapan
                  </li>
                  <li>
                    <strong>Liburan Sekolah:</strong> Menghitung durasi liburan
                  </li>
                  <li>
                    <strong>Durasi Kursus:</strong> Menghitung total durasi kursus pelatihan
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Dalam Kehidupan Pribadi:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Menghitung Usia:</strong> Mengetahui usia Anda dalam hari, bulan, dan tahun
                  </li>
                  <li>
                    <strong>Acara Khusus:</strong> Hitungan mundur untuk hari raya dan acara
                  </li>
                  <li>
                    <strong>Kenangan:</strong> Menghitung jumlah hari sejak peristiwa penting
                  </li>
                  <li>
                    <strong>Perjalanan:</strong> Merencanakan perjalanan dan menghitung durasi menginap
                  </li>
                  <li>
                    <strong>Kehamilan:</strong> Menghitung hari kehamilan dan perkiraan tanggal kelahiran
                  </li>
                  <li>
                    <strong>Hubungan:</strong> Merayakan ulang tahun pernikahan atau pertunangan
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Dalam Bidang Keuangan dan Hukum:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Pinjaman:</strong> Menghitung durasi pinjaman dan periode pembayaran
                  </li>
                  <li>
                    <strong>Investasi:</strong> Menghitung durasi investasi dan keuntungan
                  </li>
                  <li>
                    <strong>Tenggat Waktu Hukum:</strong> Menghitung periode litigasi dan batas waktu hukum
                  </li>
                  <li>
                    <strong>Sewa:</strong> Menghitung durasi kontrak sewa
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Memahami Perhitungan Perbedaan Antara Dua Tanggal</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Menghitung perbedaan antara dua tanggal memerlukan pemahaman yang akurat tentang cara kerja kalender dan perhitungan hari:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Dasar-dasar:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Hari:</strong> Satuan dasar = 24 jam
                  </li>
                  <li>
                    <strong>Minggu:</strong> 7 hari
                  </li>
                  <li>
                    <strong>Bulan:</strong> Bervariasi dari 28 hingga 31 hari
                  </li>
                  <li>
                    <strong>Tahun Biasa:</strong> 365 hari
                  </li>
                  <li>
                    <strong>Tahun Kabisat:</strong> 366 hari (setiap 4 tahun)
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Jumlah Hari dalam Bulan:
                </h3>
                <div>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Bulan</th>
                        <th>Jumlah Hari</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Januari</td>
                        <td>31 hari</td>
                      </tr>
                      <tr>
                        <td>Februari</td>
                        <td>28 atau 29 hari*</td>
                      </tr>
                      <tr>
                        <td>Maret</td>
                        <td>31 hari</td>
                      </tr>
                      <tr>
                        <td>April</td>
                        <td>30 hari</td>
                      </tr>
                      <tr>
                        <td>Mei</td>
                        <td>31 hari</td>
                      </tr>
                      <tr>
                        <td>Juni</td>
                        <td>30 hari</td>
                      </tr>
                      <tr>
                        <td>Juli</td>
                        <td>31 hari</td>
                      </tr>
                      <tr>
                        <td>Agustus</td>
                        <td>31 hari</td>
                      </tr>
                      <tr>
                        <td>September</td>
                        <td>30 hari</td>
                      </tr>
                      <tr>
                        <td>Oktober</td>
                        <td>31 hari</td>
                      </tr>
                      <tr>
                        <td>November</td>
                        <td>30 hari</td>
                      </tr>
                      <tr>
                        <td>Desember</td>
                        <td>31 hari</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p style={{ fontSize: "14px", marginTop: "10px" }}>
                  * 29 hari pada tahun kabisat
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Bagaimana Kalkulator Bekerja:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>Mengonversi kedua tanggal menjadi nilai waktu yang akurat</li>
                  <li>Menghitung perbedaan dalam milidetik</li>
                  <li>Mengonversi hasil ke berbagai satuan (hari, minggu, bulan, tahun)</li>
                  <li>Mempertimbangkan tahun kabisat dan bulan yang berbeda</li>
                  <li>Menampilkan hasil dalam berbagai cara untuk memudahkan pemahaman</li>
                </ol>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ Fitur:</strong> Kalkulator menggunakan rata-rata 30.436875 hari
                  per bulan dan 365.25 hari per tahun untuk memastikan akurasi hasil dalam jangka panjang.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Contoh Praktis Penggunaan Kalkulator Hari</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  Contoh 1: Menghitung Durasi Proyek
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Masalah:</strong> Proyek Anda dimulai pada 1 Januari 2024 dan berakhir pada 31 Maret 2024. Berapa lama proyek tersebut berlangsung?
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Solusi:</strong>
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>Masukkan tanggal mulai: 2024-01-01</li>
                  <li>Masukkan tanggal selesai: 2024-03-31</li>
                  <li>Tekan "Hitung"</li>
                  <li>Hasil: 90 hari (sekitar 3 bulan atau 12.86 minggu)</li>
                </ol>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Contoh 2: Menghitung Usia Secara Detail
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Masalah:</strong> Anda lahir pada 15 Juli 1990. Berapa usia Anda secara detail?
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Solusi:</strong>
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>Masukkan tanggal lahir: 1990-07-15</li>
                  <li>Masukkan tanggal saat ini (atau tanggal berapa pun Anda ingin menghitung usia)</li>
                  <li>Tekan "Hitung"</li>
                  <li>Anda akan mendapatkan usia dalam tahun, bulan, hari, dan jam</li>
                </ol>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Contoh 3: Hari Tersisa untuk Acara
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Masalah:</strong> Pernikahan Anda pada 20 Juni 2025. Berapa hari tersisa?
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Solusi:</strong>
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>Masukkan tanggal saat ini sebagai tanggal mulai</li>
                  <li>Masukkan tanggal acara: 2025-06-20</li>
                  <li>Tekan "Hitung"</li>
                  <li>Anda akan mengetahui jumlah hari, minggu, dan bulan tersisa</li>
                </ol>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Contoh 4: Menghitung Durasi Kontrak
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Masalah:</strong> Kontrak kerja dimulai pada 1 Agustus 2024 dan berakhir pada 31 Juli 2026. Berapa durasi kontrak?
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Solusi:</strong>
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>Masukkan tanggal mulai: 2024-08-01</li>
                  <li>Masukkan tanggal selesai: 2026-07-31</li>
                  <li>Tekan "Hitung"</li>
                  <li>Hasil: 730 hari (tepat 2 tahun)</li>
                </ol>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 Tips:</strong> Untuk menghitung hari tersisa untuk acara mendatang,
                  gunakan tanggal saat ini sebagai tanggal mulai dan tanggal mendatang sebagai tanggal selesai.
                  Untuk menghitung sejak acara berlalu, balikkan urutannya!
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Tips Menggunakan Kalkulator Hari Secara Efektif</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  Tips Umum:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Pastikan Urutan Tanggal:</strong> Tanggal mulai harus
                    sebelum tanggal selesai
                  </li>
                  <li>
                    <strong>Gunakan Format yang Sesuai:</strong> Tinjau hasil dalam berbagai
                    satuan (hari, minggu, bulan) dan pilih yang paling sesuai
                  </li>
                  <li>
                    <strong>Periksa Detail:</strong> Gunakan bagian yang dapat diperluas
                    untuk melihat informasi tambahan
                  </li>
                  <li>
                    <strong>Simpan Hasil:</strong> Ambil tangkapan layar jika Anda
                    perlu mengacu padanya nanti
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Untuk Perhitungan Akurat:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Tahun Kabisat:</strong> Kalkulator memperhitungkannya
                    secara otomatis
                  </li>
                  <li>
                    <strong>Perbedaan Bulan:</strong> Menghitung hari aktual terlepas
                    dari panjang bulan
                  </li>
                  <li>
                    <strong>Jam dan Menit:</strong> Jika Anda memerlukan akurasi lebih besar,
                    lihat bagian format tambahan
                  </li>
                  <li>
                    <strong>Kalender Masehi:</strong> Kalkulator menggunakan kalender
                    Masehi (Gregorian)
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Untuk Penggunaan Profesional:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Proyek:</strong> Gunakan hasil dalam hari untuk jadwal
                    waktu yang akurat
                  </li>
                  <li>
                    <strong>Kontrak:</strong> Hitung total durasi sebelum menandatangani
                  </li>
                  <li>
                    <strong>Faktur:</strong> Hitung periode pembayaran dan jatuh tempo dengan akurat
                  </li>
                  <li>
                    <strong>Perencanaan:</strong> Gunakan hasil untuk membuat jadwal waktu
                    yang realistis
                  </li>
                </ul>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ Fitur:</strong> Kalkulator bekerja secara instan dan tanpa
                  perlu internet setelah halaman dimuat, membuatnya ideal untuk digunakan di mana saja
                  dan kapan saja!
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Informasi Menarik tentang Kalender dan Hari</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  Fakta Menarik tentang Kalender:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Tahun Kabisat:</strong> Dinamakan demikian karena hari "meloncat" (leap)
                    satu hari tambahan
                  </li>
                  <li>
                    <strong>Kalender Masehi:</strong> Dinamai sesuai Paus Gregorius XIII yang memperbaikinya pada tahun 1582
                  </li>
                  <li>
                    <strong>Hari yang Hilang:</strong> Saat beralih dari kalender Julian
                    ke Gregorian, 10 hari "hilang"!
                  </li>
                  <li>
                    <strong>Bulan Terpanjang:</strong> Juli dan Agustus memiliki 31 hari berturut-turut
                    - ini jarang terjadi dalam kalender
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Angka Menarik:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Dalam 100 tahun:</strong> Ada 36.524 hari (dengan tahun kabisat)
                  </li>
                  <li>
                    <strong>Dalam hidup manusia:</strong> Rata-rata 80 tahun = sekitar 29.200 hari
                  </li>
                  <li>
                    <strong>Kehamilan:</strong> Sekitar 280 hari (40 minggu)
                  </li>
                  <li>
                    <strong>Periode Studi:</strong> 12 tahun sekolah = sekitar 2.160 hari sekolah
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Dalam Budaya yang Berbeda:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Kalender Hijriah:</strong> Berdasarkan siklus bulan (354 hari)
                  </li>
                  <li>
                    <strong>Kalender Cina:</strong> Menggabungkan solar dan lunar
                  </li>
                  <li>
                    <strong>Kalender Firaun:</strong> Salah satu kalender solar pertama (365 hari)
                  </li>
                  <li>
                    <strong>Kalender Maya:</strong> Sangat akurat dan kompleks
                    serta mencakup beberapa siklus
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Mengapa Februari Hanya 28 Hari?
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Dalam kalender Romawi kuno, Februari adalah bulan terakhir dalam setahun dan
                  digunakan untuk "mengoreksi" sisa hari. Ketika bulan-bulan
                  disusun ulang, Februari tetap dengan 28 hari. Pada tahun kabisat, satu hari tambahan ditambahkan ke bulan Februari
                  untuk mengkompensasi seperempat hari ekstra dalam tahun matahari (365,25 hari).
                </p>
              </div>
            </div>
          </div>
          <br />
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            Pertanyaan Umum
          </h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara menghitung perbedaan antara dua tanggal?
                </h3>
              </div>
              <div className="info-section-body">
                Menghitung perbedaan antara dua tanggal sangat sederhana:
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>Masukkan tanggal mulai di kolom pertama</li>
                  <li>Masukkan tanggal selesai di kolom kedua</li>
                  <li>Pastikan tanggal mulai sebelum tanggal selesai</li>
                  <li>Tekan tombol "Hitung"</li>
                  <li>
                    Hasil akan langsung muncul dalam berbagai satuan (hari, minggu, bulan, tahun)
                  </li>
                  <li>Anda dapat membuka bagian untuk melihat detail tambahan</li>
                </ol>
                Kalkulator mempertimbangkan tahun kabisat dan perbedaan jumlah hari setiap bulan untuk mendapatkan hasil yang akurat.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah kalkulator mempertimbangkan tahun kabisat?
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Ya, tentu saja!</strong> Kalkulator hari menghitung perbedaan dengan akurasi tinggi dengan mempertimbangkan:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Tahun Kabisat:</strong> yang memiliki 366 hari, bukan 365
                  </li>
                  <li>
                    <strong>Februari:</strong> 29 hari di tahun kabisat, 28 hari di tahun biasa
                  </li>
                  <li>
                    <strong>Perbedaan Bulan:</strong> Menghitung hari aktual setiap bulan (30 atau 31 hari)
                  </li>
                </ul>
                <p style={{ lineHeight: "1.8", marginTop: "10px" }}>
                  <strong>Aturan Tahun Kabisat:</strong>
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Tahun adalah kabisat jika habis dibagi 4</li>
                  <li>Tetapi tidak kabisat jika habis dibagi 100</li>
                  <li>Kecuali jika habis dibagi 400 (seperti 2000, 2400)</li>
                </ul>
                Oleh karena itu, Anda dapat mengandalkan kalkulator untuk mendapatkan hasil yang akurat bahkan saat menghitung periode panjang yang mencakup beberapa tahun.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara menghitung usia saya secara detail?
                </h3>
              </div>
              <div className="info-section-body">
                Untuk menghitung usia Anda secara detail menggunakan kalkulator hari:
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>Masukkan tanggal lahir Anda</strong> di kolom "Tanggal Mulai"
                  </li>
                  <li>
                    <strong>Masukkan tanggal saat ini</strong> (atau tanggal berapa pun Anda ingin menghitung usia) di kolom "Tanggal Selesai"
                  </li>
                  <li>Tekan "Hitung"</li>
                </ol>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  Anda akan mendapatkan usia Anda dalam beberapa cara:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Jumlah total hari sejak kelahiran Anda</li>
                  <li>Usia Anda dalam tahun dan bulan</li>
                  <li>Usia Anda dalam minggu</li>
                  <li>Usia Anda dalam jam dan menit (di bagian detail tambahan)</li>
                </ul>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <strong>Contoh:</strong> Jika Anda lahir pada 15 Juli 1990 dan menghitung usia pada 16 Januari 2026, Anda akan mengetahui bahwa Anda telah hidup sekitar 12.968 hari atau 35 tahun 6 bulan!
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara menghitung hari tersisa untuk acara mendatang?
                </h3>
              </div>
              <div className="info-section-body">
                Untuk menghitung hari tersisa untuk acara mendatang (ulang tahun, pernikahan, ujian, liburan):
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>Masukkan tanggal saat ini</strong> atau hari ini di kolom "Tanggal Mulai"
                  </li>
                  <li>
                    <strong>Masukkan tanggal acara mendatang</strong> di kolom "Tanggal Selesai"
                  </li>
                  <li>Tekan "Hitung"</li>
                </ol>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  Anda akan mendapatkan:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Jumlah hari tersisa dengan tepat</li>
                  <li>Jumlah minggu dan hari tersisa</li>
                  <li>Jumlah bulan dan hari tersisa</li>
                  <li>Waktu tunggu dalam jam dan menit (untuk acara yang dekat)</li>
                </ul>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <strong>Tips:</strong> Anda dapat menyimpan hasil atau mengambil tangkapan layar untuk melacak hitungan mundur!
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Dapatkah saya menggunakan kalkulator untuk tanggal di masa lalu yang jauh?
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Ya! Anda dapat menggunakan kalkulator untuk menghitung perbedaan antara dua tanggal, baik keduanya:
                </p>
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>Di masa lalu yang jauh:</strong> Seperti menghitung jumlah hari sejak peristiwa bersejarah
                  </li>
                  <li>
                    <strong>Di masa depan:</strong> Seperti merencanakan acara mendatang
                  </li>
                  <li>
                    <strong>Antara masa lalu dan sekarang:</strong> Seperti menghitung usia Anda atau durasi sejak peristiwa penting
                  </li>
                  <li>
                    <strong>Antara sekarang dan masa depan:</strong> Seperti menghitung hari tersisa untuk suatu tanggal
                  </li>
                </ul>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <strong>Catatan Penting:</strong> Kalkulator menggunakan kalender Masehi (Gregorian) yang mulai digunakan pada tahun 1582. Untuk tanggal sebelum itu, mungkin ada sedikit perbedaan karena kalender yang berbeda yang digunakan sebelumnya.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa perbedaan antara menghitung hari dalam bulan dan minggu?
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Setiap metode memiliki penggunaan yang sesuai:
                </p>
                <h4 style={{ fontSize: "15px", marginTop: "10px" }}>
                  <strong>Dalam Hari:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Paling akurat</li>
                  <li>Berguna untuk jadwal waktu yang tepat</li>
                  <li>Ideal untuk proyek dan tenggat waktu</li>
                  <li>Contoh: "Proyek akan memakan waktu 45 hari"</li>
                </ul>
                <h4 style={{ fontSize: "15px", marginTop: "10px" }}>
                  <strong>Dalam Minggu:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Mudah dipahami untuk perencanaan</li>
                  <li>Berguna untuk jadwal kerja</li>
                  <li>Ideal untuk kehamilan dan proyek jangka pendek</li>
                  <li>Contoh: "Tersisa 6 minggu 3 hari"</li>
                </ul>
                <h4 style={{ fontSize: "15px", marginTop: "10px" }}>
                  <strong>Dalam Bulan:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Cocok untuk periode menengah dan panjang</li>
                  <li>Berguna untuk kontrak dan perencanaan keuangan</li>
                  <li>Menggunakan rata-rata 30,44 hari per bulan</li>
                  <li>Contoh: "Kontrak berdurasi 18 bulan"</li>
                </ul>
                <h4 style={{ fontSize: "15px", marginTop: "10px" }}>
                  <strong>Dalam Tahun:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Untuk periode yang sangat panjang</li>
                  <li>Berguna untuk menghitung usia</li>
                  <li>Menggunakan 365,25 hari per tahun</li>
                  <li>Contoh: "Saya berusia 35 tahun 6 bulan"</li>
                </ul>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 Tips:</strong> Kalkulator menampilkan hasil dalam semua satuan,
                  pilih yang paling sesuai dengan kebutuhan Anda!
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah kalkulator akurat untuk menghitung periode panjang (tahun)?
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Ya, kalkulator sangat akurat</strong> bahkan untuk periode panjang yang mencakup puluhan tahun. Berikut cara menjamin akurasinya:
                </p>
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>Tahun Kabisat:</strong> Dihitung secara otomatis dan sangat akurat
                  </li>
                  <li>
                    <strong>Perbedaan Bulan:</strong> Mempertimbangkan bahwa bulan memiliki jumlah hari yang berbeda
                  </li>
                  <li>
                    <strong>Perhitungan Akurat:</strong> Menggunakan persamaan matematika yang tepat
                  </li>
                  <li>
                    <strong>Kalender Gregorian:</strong> Mengikuti aturan yang benar dari kalender modern
                  </li>
                </ul>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <strong>Contoh Akurasi:</strong>
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Menghitung usia seseorang yang berusia 80 tahun - akurat hingga hari</li>
                  <li>Menghitung durasi kontrak 10 tahun - akurat hingga hari</li>
                  <li>Menghitung periode antara 1990 dan 2026 - sangat akurat</li>
                </ul>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ Jaminan:</strong> Anda dapat mengandalkan kalkulator untuk perhitungan profesional dan legal karena menggunakan persamaan yang sama yang digunakan oleh sistem tanggal resmi.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Dapatkah saya menggunakan kalkulator di ponsel?
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Tentu saja!</strong> Kalkulator hari dirancang untuk bekerja secara efisien di semua perangkat:
                </p>
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>📱 Ponsel Pintar:</strong> Antarmuka responsif yang beradaptasi sempurna dengan layar kecil
                  </li>
                  <li>
                    <strong>📲 Tablet:</strong> Pengalaman ideal di iPad dan perangkat Android tablet
                  </li>
                  <li>
                    <strong>💻 Komputer:</strong> Antarmuka lengkap dengan semua fitur
                  </li>
                  <li>
                    <strong>🌐 Semua Browser:</strong> Bekerja di Chrome, Safari, Firefox, dan Edge
                  </li>
                </ul>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <strong>Fitur Tambahan untuk Ponsel:</strong>
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Pemilih tanggal bawaan sistem operasi</li>
                  <li>Kemudahan menggulir dan menekan</li>
                  <li>Bekerja instan tanpa keterlambatan</li>
                  <li>Tidak perlu aplikasi tambahan</li>
                </ul>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 Tips:</strong> Anda dapat menambahkan kalkulator ke layar utama ponsel untuk akses cepat! Cukup buka menu di browser dan pilih "Tambahkan ke layar utama".
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DaysCalculator;